// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"7918b12d","90":"cecd702e","118":"dc37fc1c","159":"50ffa4ab","237":"9f3b03ba","245":"a0be556d","284":"927a560c","562":"749a0610"}[chunkId] + ".chunk.js";
};